module.exports = __webpack_public_path__ + "src/assets/img/ohlopkov__header.51b556e0.png";